import React from 'react';

// STYLES
import { Box, Typography, Zoom } from '@mui/material';

// COMPONENTS
import ImportImage from 'js/components/TriiboComponents/ImportImage';

export const AlertImageSettings = ({ alertData, setAlertData }) => {
  const { image, type } = alertData;

  const styleContainer = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '0.6rem',

    background: '#fff',
    border: '1px solid #70707033',
    borderRadius: '5px',
    boxShadow: '0px 3px 6px #00000029',
    marginBottom: '16px',
    padding: '30px 30px',
    minHeight: '20rem',
    width: '100%',
  };

  return (
    <Zoom in={type === 'popup'} timeout={500}>
      <div style={styleContainer}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Configuração de imagem:
        </Typography>
        <Box>
          <ImportImage
            autoWidth={false}
            imageDefault={null}
            image={image}
            setImage={(newImage) =>
              setAlertData((prevAlertData) => ({ ...prevAlertData, image: newImage }))
            }
            ratio={1}
          />
        </Box>
      </div>
    </Zoom>
  );
};
